// extracted by mini-css-extract-plugin
export var content = "Tabs-module--content--f5b0e";
export var list = "Tabs-module--list--c239f";
export var listRoot = "Tabs-module--listRoot--1c77d";
export var scrollAreaRoot = "Tabs-module--scrollAreaRoot--b6932";
export var tabContainer = "Tabs-module--tabContainer--5bff6";
export var trigger = "Tabs-module--trigger--eeaa7";
export var underline = "Tabs-module--underline--d01b3";
export var underlineContainer = "Tabs-module--underlineContainer--9182a";
export var widget = "Tabs-module--widget--37259";